import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import ProjectCreatePageUI from './ProjectCreatePageUI.js'

class ProjectCreatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
    }
  }

  render() {
    return (
      <ProjectCreatePageUI
        context={this.props.context}
        messageList={this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getMessages(context) {
    let arr = [
      'c_create_project',
      'c_type',
      'c_short_code',
      'c_project_name',
      'c_template_name',
      'c_based_on',
      'c_visibility',
      'c_sharable_name',
      'c_description',
      'c_announcement',
      'c_shortcode_taskid_tip',
      'c_prj_desc_tip',
      'c_none',
      'c_create',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_prj_crt', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }

}

export default ProjectCreatePageSF
